<template>
    <div aria-labelledby="truvitoLoginModal" class="modal fade" id="truvitoLoginModal" role="dialog" tabindex="-1">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="exampleModalLabel1">Use Your Truvito Credentials</h4>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">&times;</span></button>
                </div>
                <div class="modal-body card-blue">
                    <form @submit.prevent="login" class="form-horizontal m-t-20" id="loginform">
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text"><i class="ti-user"></i></span>
                            </div>
                            <input :class="{'is-invalid': submitted && errors.has('email')}" aria-describedby="Email"
                                   aria-label="Email"
                                   class="form-control form-control-lg"
                                   data-vv-as="Email"
                                   id="email"
                                   name="email"
                                   placeholder="Email"
                                   type="text"
                                   v-model="credentials.email"
                                   v-validate="'required|email'">
                            <div class="invalid-feedback" v-if="submitted && errors.has('email')">{{ errors.first('email') }}</div>
                        </div>
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text"><i class="ti-pencil"></i></span>
                            </div>
                            <input :class="{'is-invalid': submitted && errors.has('password')}" aria-describedby="Password"
                                   aria-label="Password"
                                   class="form-control form-control-lg"
                                   data-vv-as="Password"
                                   id="password"
                                   name="password"
                                   placeholder="Password"
                                   type="password"
                                   v-model="credentials.password"
                                   v-validate="'required'">
                            <div class="invalid-feedback" v-if="submitted && errors.has('password')">{{ errors.first('password') }}</div>
                        </div>

                        <div class="form-group text-center">
                            <div class="col-xs-12 p-b-20">
                                <button class="btn btn-block btn-lg btn-acrecx" type="submit">Integrate</button>
                            </div>
                        </div>

                        <hr>

                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TruvitoLoginModal",
        data() {
            return {
                submitted: false,
                loading: false,
                credentials: {
                    email: '',
                    password: ''
                },
                loggingIn: false,
                error: ''
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                $('[data-toggle="tooltip"]').tooltip();
                $(".preloader").fadeOut();
            },

            login() {
                this.submitted = true;
                this.$validator.validate()
                .then(valid => {
                    if(valid) {
                        self.loading = true;
                        this.$http.post('/integrations/truvito', {email: this.credentials.email, password: this.credentials.password})
                        .then(reply => {
                            this.$parent.checkIntegrations();
                            $("#truvitoLoginModal").modal('toggle');
                        })
                        .catch(err => {
                            this.loginFailed(err);
                            $("#truvitoLoginModal").modal('toggle');
                        })
                    }
                });
            },
            loginFailed(err) {
                this.loading = false;

                let data = err.response.data;
                if(data.status === 404) {
                    this.$swal({
                        type: 'error',
                        title: 'Profile Not Found',
                        text: 'Your email was not found. Please make sure your email was typed correctly.',
                        timer: 5000
                    });
                } else if(data.status === 412) {
                    this.$swal({
                        type: 'error',
                        title: 'Confirmation Pending',
                        text: 'We sent you a confirmation link to your email. Please check your email and follow instructions sent there.',
                        timer: 5000
                    });
                } else {
                    this.$swal({
                        type: 'error',
                        title: 'Authentication Error',
                        text: data.description || data.detail,
                        timer: 5000
                    });
                }


            }
        }
    }
</script>

<style scoped>

</style>